import { useContext, useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { post, patch, get } from "../../../adapters/xhr/api";
import MainContent from "../../../layouts/maincontent/MainContent";

import { useNavigate, useLocation } from "react-router-dom";
import LoadingSpinner from "../../../components/Loading/LoadingSpinner";
import { previewAndDownloadDeclarationFile } from "../../../adapters/apis/UnifiedTaxDeclaration/details";

const UnifiedTaxDeclarationRecievePayment = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [backendError, setBackendError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [claim, setClaim] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        setIsLoading(true);
        try {
          const response = await get(
            `api/declaration-system/declarations/user/claims/${id}`,
            {},
            true,
          );

          if (response?.data?.data?.under_process) {
            if (parseInt(response?.data?.data?.type) === 1) {
              return navigate(
                `/tax-declaration/payment-under-account/list/${response?.data?.data?.declaration_id}`,
                { state: { activeTab: "claims" } },
              );
            } else if (parseInt(response?.data?.data?.type) === 2) {
              return navigate(
                `/payment-account-debt/list/${response?.data?.data?.declaration_id}`,
                { state: { activeTab: "claims" } },
              );
            } else if (parseInt(response?.data?.data?.type) === 3) {
              return navigate(`/my-debts`, { state: { activeTab: "claims" } });
            }
          }

          setClaim(response?.data?.data);

          if (!response?.data?.data?.visited) {
            await patch(`api/declaration-system/check-visited/${id}`, {}, {});
          } else {
            navigate(`/tax-declaration/list-data`);
          }
          setIsLoading(false);
        } catch (error) {
          navigate(`/tax-declaration/list-data`);
        }
      }
    };

    fetchData();
  }, [id]);

  const handleReSubmitPayment = async () => {
    setBackendError(null);

    try {
      const response = await post(
        `api/declaration-system/initial-payment/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      initiatePayment(response);
    } catch (error) {
      console.log("failed to create payment");
    }
  };

  const handlePreviewFile = async () => {
    let url;
    if ([1, 2].includes(parseInt(claim?.type))) {
      url = `/api/declaration-system/declarations/user/claim-details-pdf/${claim?.id}`;
    } else {
      url = `/api/declaration-system/my-debts/claim-details-pdf/${claim?.id}`;
    }
    try {
      const response = await previewAndDownloadDeclarationFile(url);

      const blob = new Blob([response?.data], {
        type: response.headers["content-type"],
      });

      // Create a URL for the blob
      const fileUrl = URL.createObjectURL(blob);
      window.open(fileUrl, "_blank");
    } catch (error) {
      if (error?.response?.status == 429) {
        alert("تعديت عدد المحاولات المسموح بها . يرجى الانتظار");
      }
    }
  };

  const initiatePayment = (response) => {
    document.initiationForm.action = response?.data?.data?.payment_gateway_url;
    document.getElementById("SenderID").value = response?.data?.data?.SenderID;
    document.getElementById("RandomSecret").value =
      response?.data?.data?.RandomSecret;
    document.getElementById("RequestObject").value =
      response?.data?.data?.RequestObject;
    document.getElementById("HashedRequestObject").value =
      response?.data?.data?.HashedRequestObject;
    document.getElementById("initiationForm").submit();
    window.scrollTo(0, 0);
  };

  return (
    <>
      <MainContent>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <form
              method="POST"
              id="initiationForm"
              name="initiationForm"
              action=""
            >
              <input type="hidden" name="SenderID" id="SenderID" value="" />
              <input
                type="hidden"
                name="RandomSecret"
                id="RandomSecret"
                value=""
              />
              <input
                type="hidden"
                name="RequestObject"
                id="RequestObject"
                value=""
              />
              <input
                type="hidden"
                name="HashedRequestObject"
                id="HashedRequestObject"
                value=""
              />
            </form>
            <section className={`section-content pt-md-0 pt-4 pb-5`}>
              <div className={`container`}>
                {backendError && (
                  <div
                    className="alert alert-danger text-center mt-3"
                    id="backend_error"
                    role="alert"
                  >
                    {backendError}
                  </div>
                )}

                <div className="container mt-5">
                  {claim?.paid ? (
                    <div className="box-content">
                      <div className="box">
                        {[1, 2].includes(parseInt(claim?.type)) && (
                          <h2 className="box-title mb-4 text-center">
                            <span className="text-success">
                              تم سداد مبلغ طلب السداد التي تم إصدارها عن
                              المدفوعات تحت{" "}
                              {parseInt(claim?.type) === 1
                                ? "الحساب"
                                : "حساب المديونيه"}
                              ،
                            </span>{" "}
                            هل ترغب في :
                          </h2>
                        )}

                        {parseInt(claim?.type) === 3 && (
                          <h2 className="box-title mb-4 text-center">
                            <span className="text-success">
                              تم سداد مبلغ طلب السداد التي تم إصدارها عن عقار
                              تحت حساب المديونية خارج نطاق الإقرار ،
                            </span>{" "}
                            هل ترغب في :
                          </h2>
                        )}

                        <div className="d-flex flex-column align-items-center gap-3">
                          {parseInt(claim?.type) === 1 && (
                            <Link
                              className="btn btn-primary col-12 col-md-5 p-3 fw-bolder"
                              to={`/tax-declaration/details/${claim?.declaration_id}`}
                            >
                              استعراض تفاصيل الإقرار{" "}
                            </Link>
                          )}
                          <Link
                            className="btn col-12 col-md-5 p-3 fw-bolder"
                            to={`${
                              parseInt(claim?.type) === 1
                                ? `/tax-declaration/payment-under-account/list/${claim?.declaration_id}`
                                : parseInt(claim?.type) === 2
                                  ? `/payment-account-debt/list/${claim?.declaration_id}`
                                  : `/my-debts`
                            }`}
                            state={{ activeTab: "claims" }}
                            style={{
                              backgroundColor: "#E3F5FF",
                              color: "#32A8ED",
                            }}
                          >
                            العودة لقائمة طلبات السداد{" "}
                          </Link>
                          <button
                            onClick={handlePreviewFile}
                            className="btn col-12 col-md-5 p-3 fw-bolder"
                            style={{
                              backgroundColor: "#0974ad",
                              color: "#eaf2f7",
                            }}
                            id="dispute_info_icon"
                          >
                            استعراض تفاصيل طلب السداد{" "}
                          </button>
                          <Link
                            className="btn btn-primary col-12 col-md-5 p-3 fw-bolder"
                            to={`${
                              parseInt(claim?.type) === 1
                                ? `/tax-declaration/list-data`
                                : parseInt(claim?.type) === 2
                                  ? `/settlement-account-debt`
                                  : `/my-debts`
                            }`}
                            style={{
                              backgroundColor: "#FFFFFF",
                              color: "#32A8ED",
                            }}
                          >
                            العودة
                          </Link>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="box-content">
                      <div className="box">
                        {[1, 2].includes(parseInt(claim?.type)) && (
                          <h2 className="box-title mb-4 text-center">
                            <span className="text-danger">
                              تعذر سداد طلب السداد لمدفوعات تحت{" "}
                              {parseInt(claim?.type) === 1
                                ? "الحساب"
                                : "حساب المديونيه"}
                              ،
                            </span>{" "}
                            هل ترغب في :
                          </h2>
                        )}

                        {parseInt(claim?.type) === 3 && (
                          <h2 className="box-title mb-4 text-center">
                            <span className="text-danger">
                              تعذر سداد طلب السداد لعقار تحت حساب المديونية خارج
                              نطاق الإقرار،
                            </span>{" "}
                            هل ترغب في :
                          </h2>
                        )}

                        <div className="d-flex flex-column align-items-center gap-3">
                          <button
                            className=" col-12 col-md-5 p-3 fw-bolder"
                            style={{
                              backgroundColor: "#FFD4D4",
                              border: "none",
                              borderRadius: "0.375rem",
                              cursor: "pointer",
                            }}
                            onClick={handleReSubmitPayment}
                          >
                            إعادة محاولة سداد المبلغ{" "}
                          </button>
                          {[1, 2].includes(parseInt(claim?.type)) && (
                            <Link
                              className="btn btn-primary col-12 col-md-5 p-3 fw-bolder"
                              to={`/tax-declaration/details/${claim?.declaration_id}`}
                            >
                              استعراض تفاصيل الإقرار{" "}
                            </Link>
                          )}

                          <Link
                            className="btn col-12 col-md-5 p-3 fw-bolder"
                            to={`${
                              parseInt(claim?.type) === 1
                                ? `/tax-declaration/payment-under-account/list/${claim?.declaration_id}`
                                : parseInt(claim?.type) === 2
                                  ? `/payment-account-debt/list/${claim?.declaration_id}`
                                  : `/my-debts`
                            }`}
                            state={{ activeTab: "claims" }}
                            style={{
                              backgroundColor: "#E3F5FF",
                              color: "#32A8ED",
                            }}
                          >
                            العودة لقائمة طلبات السداد{" "}
                          </Link>
                          <Link
                            className="btn btn-primary col-12 col-md-5 p-3 fw-bolder"
                            to={`${
                              parseInt(claim?.type) === 1
                                ? `/tax-declaration/list-data`
                                : parseInt(claim?.type) === 2
                                  ? `/settlement-account-debt`
                                  : `/my-debts`
                            }`}
                            style={{
                              backgroundColor: "#FFFFFF",
                              color: "#32A8ED",
                            }}
                          >
                            العودة
                          </Link>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </section>
          </>
        )}
      </MainContent>
      {/* )} */}
    </>
  );
};
export default UnifiedTaxDeclarationRecievePayment;
